import React from 'react';

// for multiple paragraphs in answer, add multiple nested divs
export const faqs = [
    {
        question: "What is MAGNiTT?",
        answer: <div>MAGNiTT is the first startup data platform serving founders and investors across emerging venture markets. Driven by the belief that data is the foundation of thriving entrepreneurship ecosystems, and that scale should not be constrained by a lack of information, MAGNiTT supports founders and investors with data that underpins decisions that drive expansions, investments, and exits across emerging venture markets in MENA, South Asia, and Sub-Saharan Africa.</div>
    },
    {
        question: "How do you support Investors & Corporates?",
        answer: <div>MAGNiTT is a research and analysis tool where you can discover and track new startups and potential investment targets. In addition, MAGNiTT offers a suite of tools that allow you to assess industries and markets.</div>
    },
    {
        question: "Where does your data come from?",
        answer: <div>
                    We have four sources of data:
            <ul>
                <li className="mt-3">Primary Data: User generated by VCs and founders updating their profiles on MAGNiTT</li>
                <li className="mt-1">Outreach: Regular reporting with funding institutions from across the MENA landscape</li>
                <li className="mt-1">Secondary Data: Curation from MAGNiTT Team</li>
                <li className="mt-1">Collaborations: Incoming data feeds from community partners</li>
            </ul>
        </div>
    },
    {
        question: "What data can I find here?",
        answer: <div>
            <div><a href="/startups">Startups</a>: You can find facts and information on over 15,000 MENA startups including funding history, descriptions, focus and location amongst other indicators.</div>
            <div><a href="/investors">Investors</a>: Information on over 2,000 investors and their investment activity, news, their investment mandates as well as their team members. Where available you can apply to them for funding.</div>
        </div>
    },
    {
        question: "Where can I access the research?",
        answer: <div>All MAGNiTT research can be found under the <a href="/research">Research tab</a>. This includes all historical research as well as our monthly dashboard ecosystem summary.</div>
    },
    {
        question: "What is MAGNiTT Advanced Analytics?",
        answer: <div>This new feature allows you to make your own analytical research using proprietary MAGNiTT data. As part of the <a href="/advanced-analytics">"Analytics"</a> you can view charts and comparisons using filters to make your own analysis.</div>
    },
    {
        question: "Can I get a demo?",
        answer: <div>Absolutely. Feel free to <a onClick={() => document.getElementById('demo-request').click()}>book a demo</a> with our team who will be happy to guide you through the platform and its features.</div>
    },
    {
        question: "Can I invest in companies listed on MAGNiTT?",
        answer: 
            <div>
                <div>MAGNiTT is not a funding platform, instead we provide data and intelligence to support decision-making and to help determine strategy. Hence, we are not an intermediary between startups and investors.</div>
                <div>As MAGNiTT is the largest and most detailed database of potentially investable high-growth companies in the region, you can use MAGNiTT as a research tool by creating a free account.</div>
            </div>
    },
    {
        question: "Do you help raise investment?",
        answer: <div>MAGNiTT is not a funding platform. Nevertheless, by creating a profile on MAGNiTT, investors, mentors, and potential recruits are able to connect with you using your contact details available on the platform to discuss opportunities. You can filter for investors in great detail and connect to funding institutions to scout for your next investor, accelerator, VC, or enabler. We suggest that you ensure your company profile is up to date and ready before you start searching for your next investor.</div>
    }
]